import { render, staticRenderFns } from "./RequestNewPass.vue?vue&type=template&id=16068c2d"
import script from "./RequestNewPass.vue?vue&type=script&lang=ts"
export * from "./RequestNewPass.vue?vue&type=script&lang=ts"
import style0 from "./RequestNewPass.vue?vue&type=style&index=0&id=16068c2d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports